class PopupModel {
  header: string;
  body: React.ReactNode;
  buttons: { label: string; onClick: () => void }[];
  width?: string;

  constructor(header: string, body: React.ReactNode, buttons: { label: string; onClick: () => void }[] = [], width?: string) {
    this.header = header;
    this.body = body;
    this.buttons = buttons;
    this.width = width;
    if (!width){
      this.width = '400px'; // default width
    }
  }

}

export default PopupModel;